var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{staticClass:"mr-0 overflow-y-auto",attrs:{"id":_vm.id,"options":_vm.quill_options,"state":_vm.state,"disabled":_vm.disabled},on:{"change":_vm.change},model:{value:(_vm.d_value),callback:function ($$v) {_vm.d_value=$$v},expression:"d_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }